import isArray from 'lib/functions/isArray'

const checkIsArray = array => {
  return !!array && isArray(array) && array.length > 0
}

export default checkIsArray
